/**
 * CSP Monitoring Script
 * 
 * This script monitors CSP violations and logs them
 * Can be used to debug CSP issues without breaking functionality
 */

// CSP Report Endpoint (change this to your actual reporting endpoint if you have one)
const CSP_REPORT_URL = '/api/csp-report';

/**
 * Logs CSP violations to console and optionally to a reporting endpoint
 * @param {Event} e - The securitypolicyviolation event
 */
function handleCSPViolation(e) {
  const violationInfo = {
    'violatedDirective': e.violatedDirective,
    'effectiveDirective': e.effectiveDirective,
    'blockedURI': e.blockedURI,
    'originalPolicy': e.originalPolicy,
    'disposition': e.disposition,
    'documentURI': e.documentURI,
    'timestamp': new Date().toISOString()
  };
  
  // Log to console for development/testing
  console.warn('CSP Violation:', violationInfo);
  
  // Optional: Send to reporting endpoint
  try {
    if (CSP_REPORT_URL) {
      navigator.sendBeacon(CSP_REPORT_URL, JSON.stringify({
        'csp-report': violationInfo
      }));
    }
  } catch (error) {
    console.error('Failed to send CSP violation report', error);
  }
}

/**
 * Sets up CSP monitoring
 */
function monitorCSP() {
  if (document && document.addEventListener) {
    document.addEventListener('securitypolicyviolation', handleCSPViolation);
    console.log('CSP monitoring activated');
  }
}

/**
 * Checks if CSP is correctly implemented
 */
function checkCSP() {
  // Check for CSP headers
  fetch(window.location.href)
    .then(response => {
      const cspHeader = response.headers.get('Content-Security-Policy');
      if (cspHeader) {
        console.log('CSP Header is implemented:', cspHeader);
      } else {
        console.warn('No CSP header detected. Using meta tag fallback.');
      }
    })
    .catch(error => {
      console.error('Error checking CSP implementation:', error);
    });
}

// Start monitoring CSP violations
monitorCSP();

// Check CSP implementation (only in development)
if (process.env.NODE_ENV === 'development') {
  checkCSP();
}

export { monitorCSP, checkCSP };
